import React from 'react';
import { prop } from 'js/utils/ramda.util';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import { OverflowSlider } from '../OverflowSlider';
import { GridPagingSlider } from '../GridPagingSlider';

export const Games = ({ selectedGames }) => {
    const games = useAppSelector(prop('games'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const gameCodes = selectedGames.filter(code => games[code]);

    if (!isDesktop) {
        return (
            <OverflowSlider gameCodes={gameCodes} />
        );
    }

    return (
        <GridPagingSlider gameCodes={gameCodes} />
    );
};
